import React from 'react';
import './Footer.css';
import { CONTACT_INFO } from '../constants';

const Footer = ({ onTermsClick, onPrivacyClick }) => {
  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-column-center">
            <h3>Contact Us</h3>
            <ul className="contact-info">
              <li>
                <i className="fas fa-map-marker-alt"></i> 
                Jaipur - 302021
              </li>
              <li>
                <a href={`tel:${CONTACT_INFO.PHONE.replace(/\s/g, '')}`} className="footer-phone-link">
                  <i className="fas fa-phone"></i> {CONTACT_INFO.PHONE}
                </a>
              </li>
              <li><i className="fas fa-envelope"></i> {CONTACT_INFO.EMAIL}</li>
            </ul>
          </div>
          
          <div className="footer-quick-links">
            <h3>Quick Links</h3>
            <ul className="quick-links-list">
              <li><a href="#home">Home</a></li>
              <li><a href="#rajasthan-tours">Packages</a></li>
              <li><a href="#destinations">Destinations</a></li>
              <li><a href="#experiences">Experiences</a></li>
              <li><a href="#blog-section">Mysteries</a></li>
              <li><a href="#cab-rental">Cabs</a></li>
              <li><a href="#corporate-travel">Corporate</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Kalyan Travels. All Rights Reserved.</p>
          <div className="legal-links">
            <button onClick={onTermsClick} className="terms-link">Terms & Conditions</button>
            <span className="separator">|</span>
            <button onClick={onPrivacyClick} className="terms-link">Privacy Policy</button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
